import { Action, handleActions } from 'redux-actions';
import { debug } from '../../../utils';
import actions from './actions';
import { fetch, post, changePassword, changeEmail, clear } from './actions'

interface Account {
    username: string;
    email: string;
    email_verified: boolean;
    research_participant: boolean;
}

interface AccountData {
    inProgress: boolean;
    data: Account;
}

interface AccountReducers { [actionType: string]: {(state: AccountData, action: Action<any>): AccountData };}

const _AccountReducers: AccountReducers = {
    [fetch.names.START]:  (state, action) => ({ inProgress: true, data: {} as Account }),
    [fetch.names.COMPLETED]:  (state, {payload}) => ({ inProgress: false, data: payload }),
	[fetch.names.REJECTED]:  (state, {payload}) => (null),
 [changeEmail.names.COMPLETED]: (state, {payload}) => ({
	 ...state,
	data: {
		...state.data,
	 email: payload.email
	}}),
    [actions.clear]:  (state, {payload}) => (null)
};

const initialState = null;
const AccountReducers = handleActions<AccountData>(_AccountReducers, initialState as AccountData);

export default { account: AccountReducers };



// WEBPACK FOOTER //
// ./src/app/models/Account/reducers.ts